export const ADD_COURSE_REVIEW_REQUEST = "ADD_COURSE_REVIEW_REQUEST";
export const ADD_COURSE_REVIEW_SUCCESS = "ADD_COURSE_REVIEW_SUCCESS";
export const ADD_COURSE_REVIEW_FAILURE = "ADD_COURSE_REVIEW_FAILURE";

export const ADD_INSTRUCTOR_REVIEW_REQUEST = "ADD_INSTRUCTOR_REVIEW_REQUEST";
export const ADD_INSTRUCTOR_REVIEW_SUCCESS = "ADD_INSTRUCTOR_REVIEW_SUCCESS";
export const ADD_INSTRUCTOR_REVIEW_FAILURE = "ADD_INSTRUCTOR_REVIEW_FAILURE";

export const GET_INSTRUCTOR_REVIEWS_REQUEST = "GET_INSTRUCTOR_REVIEWS_REQUEST";
export const GET_INSTRUCTOR_REVIEWS_SUCCESS = "GET_INSTRUCTOR_REVIEWS_SUCCESS";
export const GET_INSTRUCTOR_REVIEWS_FAILURE = "GET_INSTRUCTOR_REVIEWS_FAILURE";

export const GET_COURSE_REVIEWS_REQUEST = "GET_COURSE_REVIEWS_REQUEST";
export const GET_COURSE_REVIEWS_SUCCESS = "GET_COURSE_REVIEWS_SUCCESS";
export const GET_COURSE_REVIEWS_FAILURE = "GET_COURSE_REVIEWS_FAILURE";
